import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * Where the featured-devices banner goes. COR-2 decides which devices fill it; until then it
 * renders nothing, so visitors never see an empty frame.
 */
export function FeaturedDevicesSlot({ children }: { children?: ReactNode }) {
  if (!children) return null;

  return (
    <Box component="section" aria-label="Equipos destacados">
      {children}
    </Box>
  );
}
